/* Core & libraries */
import { FormattedMessage } from "react-intl";

/* Helpers, constants, custom methods, internal libraries */
import { useGenericApiFetch }  from "../endpoints/base";
import {
  DISCOUNT_TERMS_ENDPOINT,
  DISCOUNT_MODAL_FLAG_ENDPOINT,
  DISCOUNTS_DETAILS_ENDPOINT,
  CHOICE_OVERRIDE_TIER_ENDPOINT
} from "../endpoints/endpoints";
import { useUserContext } from "../contexts/userContext";
import { useNotificationContext } from "../contexts/notificationContext";

/* Components */
/* Styles */

export const useDiscountService = () => {
  const { genericApiFetch } = useGenericApiFetch();

  const userDetails = useUserContext();
  const { setNotification } = useNotificationContext();
  const providerCode = userDetails?.userInfo?.providerInfo?.providerCode;
  const companyEntityId = userDetails?.userInfo?.companyInfo?.companyEntityId;

  const postDiscountTerms = async (discountTermsData) => {
    const response = await genericApiFetch({
      url: DISCOUNT_TERMS_ENDPOINT.replace("{companyEntityId}", companyEntityId).replace("{providerCode}", providerCode?.toLowerCase()),
      method: "POST",
      data : discountTermsData,
      spinner: discountTermsData?.action === "ACCEPT" ? "discountTermsDataSpinner" : "declineOfferSpinner"
    });
    if (response.success) {
      return true
    }
    setNotification(
      "error",
      <FormattedMessage id="notifications.policyErrorTitle" />,
      <FormattedMessage id="notifications.policyErrorText" />
    );
    return false
  };

  const changeDiscountModalFlag = async (modalName) => {
    const response = await genericApiFetch({
      url: DISCOUNT_MODAL_FLAG_ENDPOINT.replace("{companyEntityId}", companyEntityId).replace("{providerCode}", providerCode?.toLowerCase()),
      method: "POST",
      data : {
        modalName: modalName
      },
      spinner: "discountModalsSpinner"
    });
    if (response.success) {
      return true
    }
    return false
  };

  const getDiscountsDetails = async () => {
    const response = await genericApiFetch({
      url: DISCOUNTS_DETAILS_ENDPOINT.replace("{providerCode}", providerCode?.toLowerCase()).replace("{companyId}", companyEntityId),
      method: "GET",
    });

    if (response.success) {
      return response.data;
    }
    setNotification(
      "error",
      <FormattedMessage id="notifications.policyErrorTitle" />,
      <FormattedMessage id="notifications.policyErrorText" />
    );
    return false;
  }

  const overrideTierProgram = async (tierCode, companyId) => {
    const response = await genericApiFetch({
      url: CHOICE_OVERRIDE_TIER_ENDPOINT.replace("{companyEntityId}", companyId),
      method: "POST",
      data : {
        tierCode: tierCode
      },
      spinner: "overrideTierProgramSpinner"
    });
    if (response.success) {
      setNotification(
        "success",
        <FormattedMessage id="notifications.overrideTierProgramSuccess" />,
        <FormattedMessage id="notifications.overrideTierProgramSuccessDescription" />
      )
      return true
    }
    setNotification(
      "error",
      <FormattedMessage id="notifications.policyErrorTitle" />,
      <FormattedMessage id="notifications.policyErrorText" />
    );
    return false
  }

  return {
    postDiscountTerms,
    changeDiscountModalFlag,
    getDiscountsDetails,
    overrideTierProgram
  };
}